// Libraries
import { Button, Flex } from '@chakra-ui/react';
// Utils
import text from '@translations/en.json';
// Types
import { BackContinueFooterProps } from './BackContinueFooter.types';

/**
 * BackContinueFooter component displays a footer with back and continue buttons.
 *
 * @component
 * @param {BackContinueFooterProps} props - The component props.
 * @param {Function} props.onBack - Callback function invoked when the "Back" button is clicked.
 * @param {string} props.backText - Text to use in the back button..
 * @param {Function} props.onContinue - Callback function invoked when the "Continue" button is clicked.
 * @param {string} props.continueText -  Text to use in the continue button..
 * @param {boolean} props.disableContinue - Flag to disable the continue button.
 * @returns {ReactElement} The BackContinueFooter component.
 */
export const BackContinueFooter = ({
  backText,
  onBack,
  continueText,
  onContinue,
  disableContinue,
  continueVariant = 'submit',
  isLoading,
  ...rest
}: BackContinueFooterProps) => {
  return (
    <Flex w='full' justify='space-between' gap={4} {...rest}>
      <Button variant='outline' shadow='md' fontSize='s' lineHeight={8} h={8} onClick={onBack}>
        {backText ?? text.back}
      </Button>
      <Button
        variant={continueVariant}
        fontSize='s'
        fontWeight='medium'
        width='fit-content'
        shadow='md'
        lineHeight={8}
        h={8}
        onClick={onContinue}
        isDisabled={disableContinue}
        isLoading={isLoading}
      >
        {continueText ?? text.continue}
      </Button>
    </Flex>
  );
};
